import { computed as u, watch as g } from "vue";
import { useInterval as h } from "../node_modules/.pnpm/@vueuse_shared@10.5.0_vue@3.3.4/node_modules/@vueuse/shared/index.js";
const T = {
  autostart: !1
};
function w(i, a, c = {}) {
  const m = {
    ...T,
    ...c
  }, { counter: n, reset: p, pause: r, resume: e } = h(1e3, { controls: !0 }), o = () => {
    r(), p();
  }, f = () => {
    o(), e();
  };
  m.autostart || o();
  const l = (t) => {
    const v = ((t > 0 ? t : 0) / 60 | 0).toString().padStart(2, "0"), d = ((t > 0 ? t : 0) % 60 | 0).toString().padStart(2, "0");
    return `${v}:${d}`;
  }, s = u(() => i - n.value), S = u(() => l(s.value));
  return g(() => s.value, (t) => {
    t > 0 || (r(), a && a());
  }), {
    start: e,
    pause: r,
    resume: e,
    reset: o,
    restart: f,
    timeElapsed: n,
    timeRemaining: s,
    stopWatch: S
  };
}
export {
  w as default,
  w as useTimer
};
